import { ReactElement, useEffect, useMemo, useRef } from 'react'
import style from './index.module.less'
import { NavBar } from 'antd-mobile'
import qs from 'query-string'
import { useHistory } from 'react-router-dom'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

function getMediaType (url: string): string {
  if (url.split('?')[0].endsWith('.m3u8')) {
    return 'application/x-mpegURL'
  }
  return 'video/mp4'
}

function Main (): ReactElement {
  const h = useHistory()
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const params = useMemo(() => {
    const s = location.search
    return qs.parse(s)
  }, [])
  useEffect(() => {
    if (typeof params.url === 'string' && params.url !== '' && videoRef.current !== null) {
      const o = videojs(videoRef.current, {
        controls: true,
        fluid: true,
        aspectRatio: '16:9',
        sources: [{
          src: params.url,
          type: getMediaType(params.url)
        }]
      })
      return () => {
        o.dispose()
      }
    }
  }, [params])
  return (
    <div className={style.container}>
      <div className={style.inner}>
        <NavBar onBack={() => { h.goBack() }}>{params.title}</NavBar>
        <div>
          <video ref={videoRef} className={`video-js vjs-big-play-centered ${style.player}`} preload="auto" playsInline webkit-playsinline="true"></video>
        </div>
      </div>
    </div>
  )
}

export default Main
